import { AccountInfo, ServiceLocation, UserDetails } from 'src/api/@generated/backend';

import { selectRequestData, selectRequestDataOrThrow } from 'src/state/request/selectors';
import { RequestType } from 'src/state/request/types';
import { RootState } from 'src/state/types';
import { getOrThrow } from 'src/utils/type-utils';

export const selectSelectedServiceLocation = (state: RootState): ServiceLocation | undefined => {
  if (!selectIsAddressSelected(state)) {
    return undefined;
  }

  return selectSelectedServiceLocationOrThrow(state);
};

export const selectIsAddressSelected = (state: RootState): boolean => state.address.addressId !== undefined;

export const selectSelectedServiceLocationOrThrow = (state: RootState): ServiceLocation =>
  getOrThrow(
    selectServiceLocationsOrThrow(state).find(
      (serviceLocation) => serviceLocation.siteId === selectSelectedAddressId(state),
    ),
    'Could not find service location',
  );

export const selectHasNoServiceLocations = (state: RootState): boolean =>
  selectServiceLocationsOrThrow(state).length === 0;

export const selectHasOnlyOneServiceLocation = (state: RootState): boolean =>
  selectServiceLocationsOrThrow(state).length === 1;

export const selectServiceLocationsOrThrow = (state: RootState): ServiceLocation[] =>
  selectSelectedAccountInfoOrThrow(state).serviceLocations;

export const selectIsUserInInfonova = (state: RootState): boolean => selectUserDetailsOrThrow(state).crmSystem === 'R6';

export const selectUserDetailsOrThrow = (state: RootState): UserDetails =>
  selectSelectedAccountInfoOrThrow(state).userDetails;

export const selectSelectedAccountInfoOrThrow = (state: RootState): AccountInfo =>
  selectRequestDataOrThrow<AccountInfo>(RequestType.GET_ACCOUNT_INFO)(state);

export const selectUserDetails = (state: RootState): UserDetails | undefined =>
  selectRequestData<AccountInfo>(RequestType.GET_ACCOUNT_INFO)(state)?.userDetails;

export const selectSelectedAddressId = (state: RootState): number | undefined => state.address.addressId;
